import { allSymbolFadeEnable, setFullScreenCelebrationFilter } from 'components/ui-helper';
import PickOneTreasureBonusRecord from 'integration/pickone-treasure-bonus-record';
import { GameType } from 'names/do-names';
import Components from 'slotworks/components/components';
import { BounceZoomIn, BounceZoomOut, FadeIn, ZoomIn } from 'slotworks/graphics/animation/base-animations';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import { Group, PIXIElement } from 'slotworks/graphics/pixi/group';
import Currency from 'slotworks/i18n/currency';
import GameState from 'slotworks/model/game-state';
import soundManager from 'slotworks/sound/sound-manager';
import Contract from 'slotworks/utils/contract';
import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';
import GameInit from 'states/game-init';

export default class ExitTeasureBonusTransition extends AbstractSceneTransition {
    layers: any = [];
    private DONT_ANIMATE = ['loading_label', 'loading_percentage', 'filter'];
    private valueTweenObject: { value: number };
    private contentContainer: any;
    private BOUNCE_TIME: number = 500;

    public in(): Contract<void> {
        return new Contract(resolve => {
            Layers.BonusForeground.getSprite("filter").visible = false;
            Layers.CelebrationBackground.setScene('bonus').execute();
            FadeIn(Layers.CelebrationBackground.getSprite('filter'), 400).execute();
            setFullScreenCelebrationFilter();
            const record = GameState.getCurrentGame().getCurrentRecord();
            const r = record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[];
            const bonusRecord = r[0];
            this.startCountUp(bonusRecord.total_win_cash);
            const value = Layers.Prompts.getBitmapText('value');
            const glow = Layers.Prompts.getAnimatedSprite('glow');
            ZoomIn(value, 600, 0, TweenJS.Easing.Bounce.Out).execute();
            ZoomIn(glow, 600, 0, TweenJS.Easing.Bounce.Out).execute();

            const content = Layers.Prompts.container.children.filter(this.byName(this.DONT_ANIMATE)) as PIXIElement[];
            this.contentContainer = Group(content, 'contentContainer');

            BounceZoomIn(this.contentContainer, this.BOUNCE_TIME)
                .then(() => {
                    GameInit.gameType = GameType.default;
                    Timer.setTimeout(() => {
                        resolve(null);
                    }, 1000);
                })
                .execute();
        });
    }

    private startCountUp(amount: number) {
        let valueText: PIXI.extras.BitmapText;
        this.valueTweenObject = { value: 0 };
        const countTween: TweenJS.Tween = new TweenJS.Tween(this.valueTweenObject);
        soundManager.customEvent('winnings_countup');

        const update = () => {
            if (valueText) {
                valueText.text = Currency.format(this.valueTweenObject.value, undefined, undefined, true, true);
            }
        };

        const complete = () => {
            Components.betBar.winnings.setWinnings(amount, amount, 750);
            soundManager.customEvent('winnings_countup_end');
            if (valueText) valueText.text = Currency.format(amount, undefined, undefined, true);
        };

        const setup = () => {
            valueText = Layers.Prompts.getBitmapText('value');
            if (valueText) valueText.text = '';
        };

        let tween = countTween;
        countTween.to({ value: 0 }, 0);
        tween.chain(
            new TweenJS.Tween(this.valueTweenObject)
                .to({ value: amount }, 1500)
                .onUpdate(update)
                .onComplete(complete)
        );
        countTween.start();
        setup();
    }

    public out(): Contract<void> {
        return new Contract(resolve => {
            BounceZoomOut(this.contentContainer, this.BOUNCE_TIME)
                .then(() => {
                    Layers.CelebrationBackground.defaultScene().execute();
                    Layers.Background.defaultScene().execute();
                    for (let i = 0; i < this.layers.length; i++) {
                        this.layers[i].show();
                    }
                    allSymbolFadeEnable();
                    resolve(null);
                })
                .execute();
        });
    }
    private byName = (filterArr: string[]) => (display: PIXI.DisplayObject) => !filterArr.some(val => val === display.name);
}



// WEBPACK FOOTER //
// ./src/transitions/exit-treasure-transition.ts